import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaselineService {

  MAX_AGE = 250.0;
  INITIAL_AGE = 34.0;
  MIN_HEIGHT = 0.1;
  MAX_HEIGHT = 400.0;
  INITIAL_HEIGHT = 178.0;
  MIN_WEIGHT = 0.1;
  INITIAL_WEIGHT = 88.45;
  MIN_BFP = 0.0;
  MAX_BFP = 100.0;
  INITIAL_BFP = 18.0;
  INITIAL_RMR = 1708.0;
  MIN_PAL = 1.0;
  INITIAL_PAL = 1.7;
  INITIAL_CARB_INTAKE_PCT = 50.0;
  INITIAL_SODIUM = 4000.0;
  INITIAL_GLYCOGEN = 0.5;
  INITIAL_DELTA_E = 0;
  INITIAL_DECW = 0;

  isMale; bfpCalc; rmrCalc; age; maximumage; height:number; weight; bfp; pal; rmr; carbIntakePct; sodium; delta_E; dECW; glycogen;

  constructor() { 
    this.Baseline(null,null,null,null,null,null,null);
  }

  Baseline = (isMale, age, height, weight, bfp, rmr, pal) => {
    this.isMale = isMale ? isMale : true;
    this.bfpCalc = this.bfpCalc || true;
    this.rmrCalc = this.rmrCalc || false;

    this.age = age || this.INITIAL_AGE;
    this.maximumage = this.MAX_AGE;

    this.height = height || this.INITIAL_HEIGHT;
    this.height = (this.height < 0.0) ? this.MIN_HEIGHT : this.height;
    this.height = (this.height > this.MAX_HEIGHT) ? this.MAX_HEIGHT : this.height;

    this.weight = weight || this.INITIAL_WEIGHT;
    this.weight = (this.weight < 0.0) ? this.MIN_WEIGHT : this.weight;

    this.bfp = bfp || this.INITIAL_BFP;
    this.bfp = (this.bfp < this.MIN_BFP) ? this.MIN_BFP : this.bfp;
    this.bfp = (this.bfp > this.MAX_BFP) ? this.MAX_BFP : this.bfp;

    this.rmr = rmr || this.INITIAL_RMR;

    this.pal = pal || this.INITIAL_PAL;
    this.pal = (this.pal < this.MIN_PAL) ? this.MIN_PAL : this.pal;

    this.carbIntakePct = this.INITIAL_CARB_INTAKE_PCT;
    this.sodium = this.INITIAL_SODIUM;
    this.delta_E = this.INITIAL_DELTA_E;
    this.dECW = this.INITIAL_DECW;
    this.glycogen = this.INITIAL_GLYCOGEN;
  };

  getNewAct = (intervention) => {
    return intervention && intervention.getAct(this);
  };

  getBFP = () => {
    if (this.bfpCalc) {
      if (this.isMale)
        this.bfp = (0.14 * this.age + 37.310000000000002 * Math.log(this.getBMI()) - 103.94);
      else
        this.bfp = (0.14 * this.age + 39.960000000000001 * Math.log(this.getBMI()) - 102.01000000000001);

      this.bfp = (this.bfp < 0.0) ? 0.0 : this.bfp;
      this.bfp = (this.bfp > 60.0) ? 60.0 : this.bfp;
    }

    return this.bfp;
  };

  getHealthyWeightRange = () => {
    var healthyWeightRange:any = {};
    healthyWeightRange.low = Math.round(18.5 * Math.pow((this.height / 100), 2));
    healthyWeightRange.high = Math.round(25 * Math.pow((this.height / 100), 2))
    return healthyWeightRange;
  };

  getRMR = () => {
    if (!this.rmrCalc) {
      if (this.isMale)
        this.rmr = (9.99 * this.weight + 625.0 * this.height / 100.0 - 4.92 * this.age + 5.0);
      else
        this.rmr = (9.99 * this.weight + 625.0 * this.height / 100.0 - 4.92 * this.age - 161.0);
    }

    return this.rmr;
  };

  getNewRMR = (newWeight, day) => {
    var rmr;

    if (this.isMale)
      rmr = 9.99 * newWeight + 625.0 * this.height / 100.0 - 4.92 * (this.age + day / 365.0) + 5.0;
    else
      rmr = 9.99 * newWeight + 625.0 * this.height / 100.0 - 4.92 * (this.age + day / 365.0) - 161.0;

    return rmr;
  };

  getMaintCals = () => {
    return this.pal * this.getRMR();
  };

  getActivityParam = () => {
    return (0.9 * this.getRMR() * this.pal - this.getRMR()) / this.weight;
  };

  getTEE = () => {
    return this.pal * this.getRMR();
  };

  getActivityExpenditure = () => {
    return this.getTEE() - this.getRMR();
  };

  getFatWeight = () => {
    return this.weight * this.getBFP() / 100.0;
  };

  getLeanWeight = () => {
    return this.weight - this.getFatWeight();
  };

  getK = () => {
    return 0.76 * this.getMaintCals() - this.delta_E - 22.0 * this.getLeanWeight() - 3.2 * this.getFatWeight() - this.getActivityParam() * this.weight;
  };

  getBMI = () => {
    return this.weight / Math.pow(this.height / 100.0, 2.0);
  };

  getNewBMI = (newWeight) => {
    return newWeight / Math.pow(this.height / 100.0, 2.0);
  };

  getECW = () => {
    var ECW;

    if (this.isMale)
      ECW = 0.025 * this.age + 9.57 * this.height + 0.191 * this.weight - 12.4;
    else
      ECW = -4.0 + 5.98 * this.height + 0.167 * this.weight;

    return ECW;
  };

  getNewECW = (days, newWeight) => {
    var ECW;

    if (this.isMale)
      ECW = 0.025 * (this.age + days / 365.0) + 9.57 * this.height + 0.191 * newWeight - 12.4;
    else
      ECW = -4.0 + 5.98 * this.height + 0.167 * newWeight;

    return ECW;
  };

  proportionalSodium = (newCals) => {
    return this.sodium * newCals / this.getMaintCals();
  };

  getCarbsIn = () => {
    return this.carbIntakePct / 100.0 * this.getMaintCals();
  };

  setCalculatedBFP = (bfpcalc) => {
    this.bfp = this.getBFP();
    this.bfpCalc = bfpcalc;
  };

  setCalculatedRMR = (rmrcalc) => {
    this.rmr = this.getRMR();
    this.rmrCalc = rmrcalc;
  };

  getGlycogenH2O = (newGlycogen) => {
    return 3.7 * (newGlycogen - this.glycogen);
  };

  getTherm = () => {
    return 0.14 * this.getTEE();
  };

  getBodyComposition = () => {
    return [
      this.weight * this.bfp / 100.0,
      this.weight * (100.0 - this.bfp) / 100.0,
      this.dECW
    ];
  };

  getNewWeight = (fat, lean, glycogen, deltaECW) => {
    return fat + lean + this.getGlycogenH2O(glycogen) + deltaECW;
  };

  getNewWeightFromBodyModel = (bodyModel) => {
    return bodyModel.fat + bodyModel.lean + this.getGlycogenH2O(bodyModel.glycogen) + bodyModel.decw;
  };

  glycogenEquation = (caloricIntake) => {
    return this.glycogen * Math.sqrt(this.carbIntakePct / 100.0 * caloricIntake / this.getCarbsIn());
  };

  deltaECWEquation = (caloricIntake) => {
    return ((this.sodium / this.getMaintCals() + 4000.0 * this.carbIntakePct / (100.0 * this.getCarbsIn())) * caloricIntake - (this.sodium + 4000.0)) / 3000.0;
  };

  getStableWeight = (fat, lean, caloricIntake) => {
    var newGlycogen = this.glycogenEquation(caloricIntake),
      glycogenH2O = this.getGlycogenH2O(newGlycogen),
      deltaECW = this.deltaECWEquation(caloricIntake);

    return fat + lean + glycogenH2O + deltaECW;
  };

  /*
  getBodyState = () => {
    return new BodyModel(this);
  };
  */
  getNewTEE = (bodyModel, dailyParams) => {
    return bodyModel.getTEE(this, dailyParams);
  };
}
